import { DcddTotalUserProps, stateStatusType } from "./actionType";

export interface FetchDcddTotalUserState {
    isLoading: boolean;
    error: string | null;
    dcddTotalUser: DcddTotalUserProps | null;
    status: stateStatusType | null;
}
export interface FetchDcddTotalUserByFilterState {
    isLoading: boolean;
    error: string | null;
    dcddTotalUserByFilter: DcddTotalUserProps | null;
    status: stateStatusType | null;
}

export const initialDcddTotalUsersState: FetchDcddTotalUserState = {
    isLoading: false,
    error: null,
    dcddTotalUser: null,
    status: null,
};
export const initialDcddTotalUsersByFilterState: FetchDcddTotalUserByFilterState = {
    isLoading: false,
    error: null,
    dcddTotalUserByFilter: null,
    status: null,
};

export interface DcddTotalUserState {
    dcddTotalUsersState: FetchDcddTotalUserState;
    dcddTotalUserByFilterState:FetchDcddTotalUserByFilterState
}

export const initialState: DcddTotalUserState = {
    dcddTotalUsersState: initialDcddTotalUsersState,
    dcddTotalUserByFilterState:initialDcddTotalUsersByFilterState
};

